/**
 * Build the gray subtitle line shown under a resource's name in the request
 * wizard search dropdowns: "Email • Title • Seniority". Any missing part is
 * dropped; when nothing is present it falls back to "No details". Centralizes
 * the format so the Resources and Assignments steps stay in sync.
 *
 * When the title and seniority are the same value (e.g. "Paralegal"), the
 * seniority is dropped so the line doesn't repeat it.
 */
export function formatResourceSubtitle(
  email?: string,
  title?: string,
  seniority?: string,
): string {
  const sameAsTitle =
    !!title &&
    !!seniority &&
    title.trim().toLowerCase() === seniority.trim().toLowerCase();

  return (
    [email, title, sameAsTitle ? undefined : seniority]
      .filter(Boolean)
      .join(' • ') || 'No details'
  );
}
